module.exports = __webpack_public_path__ + "img/avatar5.6b96490e.png";